let hasLoadedOnce = false;

function changeActiveSlide(carousel) {
  const swiperWrapper = document.querySelector(
    '.glossary-carousel .facetwp-type-alpha'
  );
  const glossaryLetters = document.querySelectorAll('.facetwp-alpha');

  glossaryLetters.forEach((letter) => {
    letter.addEventListener('click', function () {
      const letterIndex = Array.prototype.indexOf.call(
        swiperWrapper.children,
        letter
      );
      carousel.slideTo(letterIndex);
    });
  });
}

window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const glossary = document.querySelector('.glossary-carousel');

  if (glossary) {
    const glossaryCarousel = new Swiper('.glossary-carousel', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      slidesPerGroup: 7,
      slideClass: 'facetwp-alpha',
      wrapperClass: 'facetwp-type-alpha',
      watchOverflow: true,
      centerInsufficientSlides: true,
      pagination: {
        el: '.glossary-carousel__navigation .swiper-pagination',
        clickable: true,
      },
    });

    changeActiveSlide(glossaryCarousel);

    window.addEventListener('facetwp-loaded', function () {
      changeActiveSlide(glossaryCarousel);
    });
  }
});

document.addEventListener('facetwp-refresh', function () {
  const FWP = window.FWP;
  if ('undefined' !== typeof FWP) {
    if (!hasLoadedOnce) {
      hasLoadedOnce = true;
    } else {
      FWP.enable_scroll = true;
      FWP.please_scroll_there = '#listing-suppliers';
    }
    window.FWP = FWP;
  }
});
